


























import {
    computed,
    defineComponent,
    PropType,
} from '@vue/composition-api';

import SuperBetsDetails from '@modules/eventGrid/components/markets/superBets/SuperBetsDetails.vue';

import { BetBuilderPreviewSummary } from '../../types/BetBuilderPreview';
import { BetBuilderOddStatus } from '../../types/BetBuilderOdd';
import { getSummaryAsSuperbet } from '../../utils/getSummaryAsSuperbet';

export default defineComponent({
    name: 'BetBuilderSummaryEvent',
    props: {
        isExpandable: {
            type: Boolean,
            required: true,
        },
        isExpanded: {
            type: Boolean,
            required: false,
            default: false,
        },
        summary: {
            type: Object as PropType<BetBuilderPreviewSummary>,
            required: true,
        },
    },
    setup(props) {
        const isMoreInactive = computed(() => {
            if (!props.isExpandable || props.isExpanded) {
                return false;
            }

            return props.summary.legs.slice(2).some((leg) => leg.status !== BetBuilderOddStatus.Active);
        });

        function isUnavailableAtIndex(index: number) {
            return props.summary.legs[index]?.status === BetBuilderOddStatus.Unavailable;
        }

        function isBlockedAtIndex(index: number) {
            return props.summary.legs[index]?.status === BetBuilderOddStatus.Blocked;
        }

        function isNotEligibleAtIndex(index: number) {
            return isUnavailableAtIndex(index) || isBlockedAtIndex(index);
        }

        function getMessageAtIndex(index: number) {
            if (isUnavailableAtIndex(index)) {
                return 'betBuilder.unavailable';
            } else if (isBlockedAtIndex(index)) {
                return 'betBuilder.blocked';
            } else {
                return '';
            }
        }

        return {
            name: computed(() => getSummaryAsSuperbet(props.summary)),
            isMoreInactive,
            isNotEligibleAtIndex,
            getMessageAtIndex,
        };
    },
    components: {
        SuperBetsDetails,
    },
});
